<template>
  <v-app>
    <Navbar />
    <router-view></router-view>


    <a class="remove-underline" href="http://www.hematologyoutlines.com/index.php?SCREEN=disclaimers" target="_blank">
      <v-footer fixed class="hidden-xs-only mt-5 grey--text caption">
        All information (including use of the photographs and charts) is for
  individual educational purpose and should not be used for any other purpose. Click/tap for details.

      </v-footer>
    </a>


    <a class="remove-underline " href="http://www.hematologyoutlines.com/index.php?SCREEN=disclaimers" target="_blank">
      <v-footer class="mt-5 grey--text text--lighten-1 caption hidden-sm-and-up">
        All information (including use of the photographs and charts) is for
  individual educational purpose and should not be used for any other purpose. Click/tap for details.

      </v-footer>
    </a>

  </v-app>
</template>

<script>
import Navbar from '@/components/Navbar'
export default {
  name: 'App',
  components: {
    Navbar

  },
  data: () => ({
    //
  }),
  mounted() {


  },
  methods: {
    openDisclamerDetails(){
      window.open("")
    }

  }
};
</script>
<style>
.remove-underline {
  text-decoration: none;
}
</style>
